import React from 'react';
import "./About.css";
import Content from "./Content";
import MyImg from "../assets/myImg.png"


// src="https://media-exp1.licdn.com/dms/image/C5603AQE9KwsOkNUprw/profile-displayphoto-shrink_400_400/0/1627833779561?e=1666224000&v=beta&t=mA2vH_Y4P8O47Wn_3v5JHeIOqDtvtTdBSKCyWRw6Fcs"
function About() {
  return (
    <div className='about' >
      <div className='about__content'>
      <Content />
      </div>
      <div className='about__image'>
        <div className='about__right'>
      <img className="myImg" src={MyImg} alt="my_image"/>
        </div>
      </div>
    </div>
  )
}

export default About;